import './topNavigationHeader.scss'
import { JSX, useEffect, useState } from 'react'
import { Logo } from '../logo/logo'
import { manager } from '../../../main'
import { CloseIcon } from '@assets/icons'
import { useLocation } from 'react-router'
import { routes } from 'navigation'

export const TopNavigationHeader = (): JSX.Element => {
  const [visible, setVisible] = useState(true)

  const location = useLocation()

  useEffect(() => {
    setVisible(location?.pathname === routes.auth.home)
  }, [location])

  return visible ? (
    <div className='webview-header w-100'>
      <div className='d-flex align-center w-100'>
        <button
          disabled={!manager?.embedded}
          className='webview-header__left'
          onClick={() => {
            if (manager?.embedded) {
              manager.goBack()
            }
          }}
        >
          <CloseIcon size={18} color='iconNeutralStrong' />
        </button>
        <div className='webview-header__logo w-100 d-flex justify-center'>
          <Logo />
        </div>
        <div className='webview-header__right'></div>
      </div>
    </div>
  ) : null
}
